module.exports = __webpack_public_path__ + "img/floor.4dde6bf0.svg";